import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { getCatalogCoverLotsTransformed } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { ImageSource } from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/AutomatedCatalogCarouselCard.types';
import { useAppSelector } from '@/redux/hooks';
import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';
import AutomatedCatalogCarouselCardItemImage from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/components/ItemImages/components/AutomatedCatalogCarouselCardItemImage';

type Props = {
    catalogId: number;
};

const AutomatedCatalogCarouselCardItemImages = ({ catalogId }: Props) => {
    const isMobile = useIsMobileLayout();
    const {
        primaryImage,
        primaryImageHighDpi,
        primaryItemId,
        primaryItemTitle,
        secondaryImage,
        secondaryImageHighDpi,
        secondaryItemId,
        secondaryItemTitle,
        tertiaryImage,
        tertiaryImageHighDpi,
        tertiaryItemId,
        tertiaryItemTitle,
    } = useAppSelector((state) => getCatalogCoverLotsTransformed(state, catalogId));

    return (
        <div
            className={cn('relative my-auto flex', {
                'gap-sm': !isMobile,
                'gap-xs': isMobile,
            })}
        >
            <AutomatedCatalogCarouselCardItemImage
                alt={primaryItemTitle}
                catalogId={catalogId}
                imageSource={ImageSource.Primary}
                itemId={primaryItemId}
                src={isMobile ? primaryImage : primaryImageHighDpi}
            />
            <AutomatedCatalogCarouselCardItemImage
                alt={secondaryItemTitle}
                catalogId={catalogId}
                imageSource={ImageSource.Secondary}
                itemId={secondaryItemId}
                src={isMobile ? secondaryImage : secondaryImageHighDpi}
            />
            <AutomatedCatalogCarouselCardItemImage
                alt={tertiaryItemTitle}
                catalogId={catalogId}
                imageSource={ImageSource.Tertiary}
                itemId={tertiaryItemId}
                src={isMobile ? tertiaryImage : tertiaryImageHighDpi}
            />
        </div>
    );
};

export default AutomatedCatalogCarouselCardItemImages;
